import TemperatureConversionExplanation from './TemperatureConversionExplanation';
import LengthConversionExplanation from './LengthConversionExplanation';
import WeightConversionExplanation from './WeightConversionExplanation';
import PowerConversionExplanation from './PowerConversionExplanation';
import VoltageConversionExplanation from './VoltageConversionExplanation';
import ElectricChargeConversionExplanation from './ElectricChargeConversionExplanation';
import FrequencyConversionExplanation from './FrequencyConversionExplanation';
import ColorConversionExplanation from './ColorConversionExplanation';
import ResistanceConversionExplanation from './ResistanceConversionExplanation';
// Import future explanations here

export const conversionExplanations = {
  temperature: TemperatureConversionExplanation,
  length: LengthConversionExplanation,
  weight: WeightConversionExplanation,
  power: PowerConversionExplanation,
  voltage: VoltageConversionExplanation,
  electricCharge: ElectricChargeConversionExplanation,
  frequency: FrequencyConversionExplanation,
  color: ColorConversionExplanation,
  resistance: ResistanceConversionExplanation,
  // Add future mappings here
}; 